import axios from 'axios';
import {
  BANK_LIST,
  BUSINESS_BANK_ACCOUNTS,
  BUSINESS_BANK_ACCOUNT,
  UPDATE_BUSINESS_BANK_ACCOUNTS,
  BUSINESS_BANK_ACCOUNTS_BY_KEYWORD,
  LINK_BUSINESS_BANK_ACCOUNTS_TO_OUTLET,
  UNLINK_BUSINESS_BANK_ACCOUNTS_TO_OUTLET,
  CREATE_BANK_ACCOUNTS,
  UPDATE_BANK_ACCOUNTS,
  DELETE_BANK_ACCOUNTS,
  GET_BANK_ACCOUNT_ACTIVITY_LOGS,
} from './constant';

export function getAllBanks() {
  return axios.get(BANK_LIST);
}

export function getAllBackAccounts() {
  return axios.get(BUSINESS_BANK_ACCOUNTS);
}

export function getAllBankAccountsByKeyword(keyword) {
  return axios.get(BUSINESS_BANK_ACCOUNTS_BY_KEYWORD(keyword));
}

export function postNewBankAccount(request) {
  return axios.post(BUSINESS_BANK_ACCOUNT, request);
}

export function updateBankAccount(request, bankAccId) {
  return axios.put(UPDATE_BUSINESS_BANK_ACCOUNTS(bankAccId), request);
}

export function linkBankAccountToOutlets(request) {
  return axios.post(LINK_BUSINESS_BANK_ACCOUNTS_TO_OUTLET, request);
}

export function unlinkBankAccountFromOutlets(request) {
  return axios.post(UNLINK_BUSINESS_BANK_ACCOUNTS_TO_OUTLET, request);
}

export function postNewBankAccountV2(request) {
  return axios.post(CREATE_BANK_ACCOUNTS, request).catch(reject);
}

export function updateBankAccountV2(request, bankAccId) {
  return axios.put(UPDATE_BANK_ACCOUNTS(bankAccId), request).catch(reject);
}

export function deleteBankAccount(bankAccId) {
  return axios.delete(DELETE_BANK_ACCOUNTS(bankAccId)).catch(reject);
}

export function getActivityLogs(page, size) {
  return axios.get(GET_BANK_ACCOUNT_ACTIVITY_LOGS(page, size)).catch(reject);
}

function reject(error) {
  let eobj;
  if (error.response) {
    const { data } = error.response;
    if (data.errors) {
      eobj = new Error(data.errors[0].code);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return Promise.reject(eobj);
}
